import axios from 'axios';
import { globalURLS } from '../../Global/urls.js';

export type DndListType = 'email' | 'phone';

export interface DndListItem {
    id: number;
    value: string;
}

export interface DndListResponse {
    items: DndListItem[];
    total: number;
    page: number;
    page_size: number;
}

const post = async <T>(endpoint: string, body: Record<string, unknown> = {}): Promise<T> => {
    const response = await axios.post(`${globalURLS.baseURL}dnd/${endpoint}`, body, globalURLS.config);
    if (!response.data?.success) {
        throw new Error(response.data?.message || 'Request failed');
    }
    return response.data.data as T;
};

export const getDndList = (params: {
    type: DndListType;
    page: number;
    page_size: number;
    search?: string;
}) => {
    const body: Record<string, unknown> = {
        type: params.type,
        page: params.page,
        page_size: params.page_size,
    };
    const search = params.search?.trim();
    if (search) {
        body.search = search;
    }
    return post<DndListResponse>('get_list', body);
};

export const addDndEmail = (email: string) =>
    post<{ id: number; value: string }>('add_email', { email: email.trim() });

export const addDndPhone = (phone: string) =>
    post<{ id: number; value: string }>('add_phone', { phone: phone.trim() });

export const removeDndEmail = (id: number) => post('remove_email', { id });

export const removeDndPhone = (id: number) => post('remove_phone', { id });

export const downloadDndCsv = async (type: DndListType): Promise<Blob> => {
    const response = await axios.post(
        `${globalURLS.baseURL}dnd/download_csv`,
        { type },
        {
            ...globalURLS.config,
            responseType: 'blob',
        },
    );
    return response.data;
};
